import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullscreenImageViewerComponent } from './fullscreen-image-viewer.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [FullscreenImageViewerComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [FullscreenImageViewerComponent]
})
export class ModelImageFullscreenViewModule {}
